var _classCallCheck = require("/home/chad.schellenger/Development/shopwcw/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/chad.schellenger/Development/shopwcw/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Address = require('./Address');

var Cart = require('./Cart');

var Order =
/*#__PURE__*/
function () {
  "use strict";

  function Order(cart) {
    _classCallCheck(this, Order);

    this.cart = cart;
    this.email = '';
    this.notes = '';
    this.createdAt = Math.floor(new Date().getTime() / 1000);
    this.shippingAddress = new Address.address();
    this.shippingCost = null;
    this.totalCost = null;
    this.trackingNumber = null;
    this.orderId = null;
    this.stockingNames = [];
    this.updatedAt = this.createdAt;
    this.status = 'pending';
    this.expiresAt = this.createdAt + 86400;
    this.quantityChristmas = this.quantityChristmas.bind(this);
  }

  _createClass(Order, [{
    key: "quantityChristmas",
    value: function quantityChristmas() {
      var count = 0;
      Object.values(this.cart.items).forEach(function (item) {
        if (item.sku.isChristmas() === true || item.addStockings) {
          console.log("Found christmas item: %s, %s", item.sku.id, item.sku.xmas);
          count += item.quantity;
        } else {
          console.log("Found non-christmas item: %s, %s", item.sku.id, item.sku.xmas);
        }
      });
      return count;
    }
  }]);

  return Order;
}();

function createOrder(obj) {
  var cart = Cart.createCart(obj.cart);
  var order = new Order(cart);
  order.createdAt = obj.createdAt;
  order.updatedAt = obj.updatedAt;
  order.expiresAt = obj.expiresAt;
  order.status = obj.status;
  order.shippingAddress = Address.createAddress(obj.shippingAddress);
  order.shippingCost = obj.shippingCost;
  order.totalCost = obj.totalCost;
  order.trackingNumber = obj.trackingNumber;
  order.email = obj.email;
  order.notes = obj.notes;
  order.orderId = obj.orderId;
  order.stockingNames = obj.stockingNames;
  return order;
}

function cleanForDynamo(order) {
  Address.cleanForDynamo(order.shippingAddress);
  Cart.cleanForDynamo(order.cart);

  if (order.email === '') {
    order.email = null;
  }

  if (order.notes === '') {
    order.notes = null;
  }

  if (order.trackingNumber === '') {
    order.trackingNumber = null;
  }

  order.stockingNames = order.stockingNames != null ? order.stockingNames.filter(function (s) {
    return s !== '';
  }) : [];
}

module.exports = {
  order: Order,
  createOrder: createOrder,
  cleanForDynamo: cleanForDynamo
};